export const isEmpty = (obj: any): boolean =>
  [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;

export const noop = (): undefined => {};

// Caution: This function does not handle all edge cases (e.g., NaN) - TMA (Jan 2026)
// Consider node:assert (http://nodejs.org/api/assert.html) .deepStrictEqual() for more complex applications.
//  - 'resolve.fallback: { assert: require.resolve("assert") }' in webpack.common.config.js
//  - 'yarn add assert'
export const isEqual = (x: any, y: any): boolean => {
  if (x && y && x.constructor !== y.constructor) return false;

  if (x instanceof Date) {
    return y instanceof Date && x.valueOf() === y.valueOf();
  }

  if (x && y && typeof x === 'object' && typeof y === 'object') {
    return (
      Object.keys(x).length === Object.keys(y).length &&
      Object.keys(x).every(key => isEqual(x[key], y[key]))
    );
  }

  return x === y;
};
